import React from "react";
import styles from "../styles/Loader.module.scss";

type LoaderProps = {
  backgroundColor?: string;
  textColor?: string;
};

export default function Loader({ backgroundColor, textColor }: LoaderProps) {
  return (
    <div
      className={styles.loader}
      style={backgroundColor ? {backgroundColor: backgroundColor} : {backgroundColor: "#1e1e1e"} }
    >
      <div className={styles.loadingMessageContainer}>
        <img
          className={styles.logo}
          alt="logo"
          src="https://frontend-assets.buildbox.com/bb_logo_new_morph_black.gif"
        />
        <p
          className={styles.message}
          style={textColor ? { color: textColor } : { color: "#fff"}}
        >
          Loading...
        </p>
      </div>
    </div>
  );
}
